<script>
export default {
	name: 'QuizRankingAnswer',
	template: `<slot v-bind="self" />`,

	props: {
		quiz_answers: Array,
		filling_type: String
	},

	data() {
		return {
			answers: this.quiz_answers.sort((a, b) => a.pos - b.pos)
		}
	},

	computed: {
		self() {
			return this;
		},
	},

	mounted() {
		console.log('QuizRankingAnswer mounted')
	},

	methods: {
		createBlankAnswer() {
			var answer = {
				"body": null,
				"correct": null,
				"pos": this.answers.length+1,
				"secondary_body":null
			}
			this.answers.push(answer)
		},

		deleteAnswer(answer) {
			this.answers.splice(this.answers.indexOf(answer), 1)
		},
	}
}
</script>
